import React from "react"

export const BlockQuote = ({children}) => {
  return(
      <blockquote
      style={{
        borderLeft: "4px solid lightgray",
        padding: "0 15px",
        margin: "15px 0 15px 0",
        marginInlineStart: "auto",
        marginInlineEnd: "auto",
      }}
    >
      {children}
    </blockquote>
  )
}